/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
import { ModalBody, ModalFooter, ModalHeader, ModalNext, Icon, useModal, Loader } from '@jutro/components';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import _, { update } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { TranslatorContext } from '@jutro/locale';
import {
    JobService,
    SubmissionService,
    UserService,
} from 'gw-capability-gateway';

import metadata from './CommercialPolicyDetailsAccordion.metadata.json5';
import styles from './CommercialPolicyDetailsAccordion.module.scss'


import { Button, CheckboxField, Radio, RadioField } from '@jutro/legacy/components';


const CommercialPolicyDetailsAccordion = props => {
    const {
        policyDetailsData, producerOfServiceValue, producerOfRecordValue
    } = props;

    
    const overrideProps = {
        '@field': {           
            className:styles.fieldStyle
        },
        producerOfRecord: {
            value: producerOfRecordValue
        },
        producerOfService: {
            value: producerOfServiceValue
        },
        preRenewalDirection: {
            value: !_.isUndefined(_.get(policyDetailsData, 'latestPeriod.preRenewalDirection_Ext')) ? _.get(policyDetailsData, 'latestPeriod.preRenewalDirection_Ext') : 'None'
        },
        totalAssociationSurcharge: {
            visible: _.get(policyDetailsData, 'latestPeriod.totalAssociationSurcharge_TWIA.amount') > 0
        },
        totalAssociationSeparator: {
            visible: _.get(policyDetailsData, 'latestPeriod.totalAssociationSurcharge_TWIA.amount') > 0
        }
    };


    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {

        }
    };




    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            model={policyDetailsData}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
};


CommercialPolicyDetailsAccordion.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({}),
};
export default CommercialPolicyDetailsAccordion;
